export default __webpack_public_path__ + "static/media/logo-bpom.f2b034a2.png";